import React from 'react'
import { cx } from '@/lib/utils'
import styles from './PageShell.module.scss'

const PUBLIC_SHELL_CLASS = 'fe-public'

export const PageShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={cx(PUBLIC_SHELL_CLASS, styles.shell)}>{children}</div>
)

export const PageMain: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <main className={styles.main}>{children}</main>
)
